import { createFileRoute } from '@tanstack/react-router';
import { Helmet } from 'react-helmet-async';
import {
  GoogleBusinessOAuthCallbackPage,
  type GoogleBusinessOAuthCallbackParams,
} from '@/features/integrations/google-business/google-business-oauth-callback-page';
import { formatDocumentTitle } from '@/lib/document-title';

const readParam = (value: unknown): string | undefined =>
  typeof value === 'string' && value.length > 0 ? value : undefined;

/**
 * Google sign-in redirect target for every salon's Google Business Profile connection. Must match the API's
 * `GOOGLE_BUSINESS_OAUTH_REDIRECT_URI` exactly (e.g. `https://app.example.com/google-business/callback`) and be
 * listed in the Google Cloud OAuth client's "Authorized redirect URIs".
 */
export const Route = createFileRoute('/_auth/google-business/callback')({
  validateSearch: (search: Record<string, unknown>): GoogleBusinessOAuthCallbackParams => ({
    code: readParam(search.code),
    state: readParam(search.state),
    error: readParam(search.error),
  }),
  component: GoogleBusinessOAuthCallbackRoute,
});

function GoogleBusinessOAuthCallbackRoute() {
  const { code, state, error } = Route.useSearch();
  return (
    <>
      <Helmet defer={false}>
        <title>{formatDocumentTitle('Connecting Google')}</title>
      </Helmet>
      <GoogleBusinessOAuthCallbackPage code={code} state={state} error={error} />
    </>
  );
}
